// import React, { useEffect } from "react";
// import {
//   Route,
//   Routes,
//   useNavigate,
//   useLocation,
//   Navigate,
// } from "react-router-dom";
// import { useAuth0 } from "@auth0/auth0-react";
// import { useUserStore } from "./context/useUserStore";
// import { ToastContainer } from "react-toastify";

// import SpecificAPI from "./services/SpecificApi";

// import ModuleDashboard from "./views/CommonPages/ModulePage";
// import DepartmentPage from "./views/CommonPages/DepartmentPage";
// import MainLayout from "./views/MainLayout";
// import ChatDashboard from "./views/CommonPages/ChatPage";
// import PromptsPage from "./views/CommonPages/PromptsPage";
// import DepartmentManagment from "./views/RootPages/Department/DepartmentManagment";
// import StaffManagement from "./views/RootPages/Staff/StaffManagement";
// import SidebarLayout from "./views/SidebarLayout";
// import ResoucesComponet from "./views/Components/ResourceLibrary/ResoucesPage";
// import SchoolPage from "./views/CommonPages/SchoolPage";
// import DocumentsPage from "views/CommonPages/DocumentsPage";
// import PromptCatMangment from "views/RootPages/PromptCategories/PromptCatMangment";
// import PromptMangment from "views/RootPages/Prompt/PromptMangment";
// import PromptTemplateManagment from "views/RootPages/PromptTemplate/PromptTemplateManagment";
// import ModuleManagment from "views/RootPages/Modules/ModuleManagment";

// import "react-toastify/dist/ReactToastify.css";

// const App = () => {
//   const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth0();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { authUser, appUser, loading } = useUserStore();

//   // Set background color based on route
//   useEffect(() => {
//     if (location.pathname === "/login") {
//       document.body.classList.add("login-bg");
//       document.body.classList.remove("dashboard-bg");
//     } else {
//       document.body.classList.add("dashboard-bg");
//       document.body.classList.remove("login-bg");
//     }
//   }, [location]);

//   // Redirect to login page only when loading is finished
//   useEffect(() => {
//     processAuthentication();
//   }, [isLoading, isAuthenticated, appUser]);

//   const processAuthentication = async () => {
//     if (isLoading) return;

//     if (!isAuthenticated) {
//       loginWithRedirect({
//         appState: { returnTo: "/" },
//       });
//     } else if (isAuthenticated && !loading && appUser) {
//       // const response = await SpecificAPI.getUsers({ auth0_id: user.sub });
//       // const userData = response.data[0] || {};

//       if (window.location.pathname=="/") {
//         navigate("/schools");
//       }
//     }
//   };

//   if (isLoading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} theme="dark" style={{ zIndex: 999999999999 }}  />

//       <Routes>
//         {/* Protected Routes */}
//         <Route path="/" element={<MainLayout />}>
//           {/* {appUser?.role === "root" && ( */}
//             <Route path="/schools" element={<SchoolPage />} />
//           {/* )} */}
//           <Route
//             path="/services/:departmentId?"
//             element={<ModuleDashboard />}
//           />
//           <Route path="/departments" element={<DepartmentPage />} />
//           {appUser?.role != "student" && (
//             <Route
//               path="/prompt-categories/:moduleId?/:departmentId?"
//               element={<PromptsPage />}
//             />
//           )}

//           {/* <Route path="/student-classroom" element={<DepartmentPage />} /> */}
//           {/* <Route path="*" element={loading || !appUser ? (
//               <div /> // or spinner
//             ) : appUser.role === "root" ? (
//               <Navigate to="/schools" replace />
//             ) : (
//               <Navigate to="/departments" replace />
//             )} />
//         </Route> */}
//         {/* <Route path="*" element={loading || !appUser ? <div />:<Navigate to="/schools" replace />} /> */}
//         </Route>

//         {/* Protected Sidebar Routes (separate layout) */}
//         <Route path="/edu-prompt" element={<SidebarLayout />}>
//           <Route
//             path="history/module/:moduleId/:departmentId/:historyId?"
//             element={<ChatDashboard />}
//           />

//           <Route
//             path="history/department/:departmentId/:historyId?"
//             element={<ChatDashboard />}
//           />
//           {/* <Route
//             path="students-chat/:classroomId"
//             element={<ChatDashboard />}
//           /> */}

//           <Route
//             path="resources/:moduleId/:departmentId"
//             element={<ResoucesComponet />}
//           />

//           <Route
//             path="documents/:moduleId/:departmentId"
//             element={<DocumentsPage />}
//           />

//           {appUser?.role == "root" && (
//             <Route
//               path="department-management"
//               element={<DepartmentManagment />}
//             />
//           )}
//           {appUser?.role == "root" && (
//             <Route path="staff-management" element={<StaffManagement />} />
//           )}
//           <Route path="resources" element={<ResoucesComponet />} />
//           {appUser?.role == "root" && <Route path="module-managment" element={<ModuleManagment />} />}
//           {appUser?.role == "root" && <Route
//             path="prompt-category-managment"
//             element={<PromptCatMangment />}
//           />}
//           {appUser?.role == "root" && <Route path="prompt-managment" element={<PromptMangment />} />}
//           {appUser?.role == "root" && <Route path="prompt-template-managment" element={<PromptTemplateManagment />} />}

//           {/* <Route path="*" element={
//             loading || !appUser ? (
//               <div /> // or spinner
//             ) : appUser.role === "root" ? (
//               <Navigate to="/schools" replace />
//             ) : (
//               <Navigate to="/departments" replace />
//             )
//           } /> */}
//           {/* <Route path="*" element={loading || !appUser ? <div />:<Navigate to="/schools" replace />} /> */}
//         </Route>
//         {/* <Route
//           path="*"
//           element={
//             loading || !appUser ? (
//               <div /> // or spinner
//             ) : appUser.role === "root" ? (
//               <Navigate to="/schools" replace />
//             ) : (
//               <Navigate to="/departments" replace />
//             )
//           }
//         /> */}
//       </Routes>
//     </>
//   );
// };

// export default App;

import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { ToastContainer } from "react-toastify";

import { useUserStore } from "./context/useUserStore";

import MainLayout from "./views/MainLayout";
import SidebarLayout from "./views/SidebarLayout";

// Common Pages
import OrganizationPage from "./views/CommonPages/OrganizationPage";
import DepartmentPage from "./views/CommonPages/DepartmentPage";
import ModuleDashboard from "./views/CommonPages/ModulePage";
import ChatDashboard from "./views/CommonPages/ChatPage";
import PromptsPage from "./views/CommonPages/PromptsPage";
import DocumentsPage from "./views/CommonPages/DocumentsPage";

// Root Pages
import DepartmentManagment from "./views/RootPages/Department/DepartmentManagment";
import StaffManagement from "./views/RootPages/Staff/StaffManagement";
import PromptCatMangment from "./views/RootPages/PromptCategories/PromptCatMangment";
import PromptMangment from "./views/RootPages/Prompt/PromptMangment";
import PromptTemplateManagment from "./views/RootPages/PromptTemplate/PromptTemplateManagment";
import ModuleManagment from "./views/RootPages/Modules/ModuleManagment";
import CreditManagement from "./views/RootPages/CreditManagement/credit-management";
import AnalyticsDashboard from "views/RootPages/Analytics/analytics-dashboard";

// Components
import ResoucesComponet from "./views/Components/ResourceLibrary/ResoucesPage";
import LoadingSpinner from "views/Components/LoadingSpinner";

import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { appUser, isAppUserLoading: userLoading } = useUserStore();

  const navigate = useNavigate();
  const location = useLocation();

  const isRoot = appUser?.role === "root";
  const isStudent = appUser?.role === "student";

  useEffect(() => {
    document.body.classList.toggle("login-bg", location.pathname === "/login");
    document.body.classList.toggle(
      "dashboard-bg",
      location.pathname !== "/login",
    );
  }, [location.pathname]);

  //   useEffect(() => {
  //   if (isLoading || userLoading) return;

  //   if (!isAuthenticated && !isLoading && !userLoading) {
  //     loginWithRedirect({ appState: { returnTo: "/" } });
  //     return;
  //   }

  //   // Only redirect to /schools once, when at "/"
  //   if (isAuthenticated && appUser && location.pathname === "/") {
  //     navigate("/schools", { replace: true });
  //   }
  // }, [isAuthenticated, isLoading, userLoading, appUser, location.pathname]);

  useEffect(() => {
    if (isLoading || userLoading) return;

    if (!isAuthenticated) {
      loginWithRedirect({ appState: { returnTo: "/" } });
      return;
    }

    if (isAuthenticated && appUser && location.pathname === "/") {
      navigate("/schools", { replace: true });
    }
  }, [isAuthenticated, isLoading, userLoading, appUser, location.pathname]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="dark"
        style={{ zIndex: 99999999999 }}
      />

      <Routes>
        {/* ---------------- Main Layout ---------------- */}
        <Route element={<MainLayout />}>
          <Route path="/schools" element={<OrganizationPage />} />
          <Route path="/departments" element={<DepartmentPage />} />
          <Route
            path="/services/:departmentId?"
            element={<ModuleDashboard />}
          />

          {!isStudent && (
            <Route
              path="/prompt-categories/:moduleId?/:departmentId?"
              element={<PromptsPage />}
            />
          )}
          <Route
            path="*"
            element={
              userLoading || !appUser ? (
                <div />
              ) : (
                <Navigate to="/schools" replace />
              )
            }
          />
        </Route>

        {/* ---------------- Sidebar Layout ---------------- */}
        <Route path="/edu-prompt" element={<SidebarLayout />}>
          <Route
            path="history/module/:moduleId/:departmentId/:historyId?"
            element={<ChatDashboard />}
          />
          <Route
            path="history/department/:departmentId/:historyId?"
            element={<ChatDashboard />}
          />

          <Route
            path="resources/:moduleId/:departmentId"
            element={<ResoucesComponet />}
          />

          <Route
            path="documents/:moduleId/:departmentId"
            element={<DocumentsPage />}
          />

          {isRoot && (
            <>
              <Route
                path="department-management"
                element={<DepartmentManagment />}
              />
              <Route path="staff-management" element={<StaffManagement />} />
              <Route path="module-managment" element={<ModuleManagment />} />
              <Route
                path="prompt-category-managment"
                element={<PromptCatMangment />}
              />
              <Route path="prompt-managment" element={<PromptMangment />} />
              <Route
                path="prompt-template-managment"
                element={<PromptTemplateManagment />}
              />
              <Route path="resources" element={<ResoucesComponet />} />
              <Route path="credit-management" element={<CreditManagement />} />
              <Route path="analytics" element={<AnalyticsDashboard />} />
            </>
          )}
        </Route>
        <Route path="*" element={<Navigate to="/schools" replace />} />
      </Routes>
    </>
  );
};

export default App;
